import React from 'react';
import './HistoricalTop20Modal.css';

function HistoricalTop20Modal({ raceName, raceId, historicalData, allRiders, onRiderClick, onClose, modalId, onOpenNotes }) {
    // Find the specific race data - use loose equality or Number() to be robust against type mismatches
    const raceData = historicalData && Array.isArray(historicalData)
        ? historicalData.find(d => Number(d.CompetitionId) === Number(raceId))
        : null;

    if (!raceData) {
        return (
            <div className="top20-modal-overlay" onClick={(e) => { onClose(e); }}>
                <div className="top20-modal-content modal-box" data-modal-id={modalId} onClick={e => e.stopPropagation()}>
                    <div className="top20-modal-header">
                        <h3>Top 20: {raceName}</h3>
                        <button className="top20-close-btn" onClick={(e) => { 
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setTimeout(onClose, 50); 
                        }}>✕</button>
                    </div>
                    <div className="top20-no-data">
                        Geen historische data gevonden voor deze wedstrijd.
                    </div>
                </div>
            </div>
        );
    }

    const years = ["2025", "2024", "2023"];
    const ranks = Array.from({ length: 20 }, (_, i) => i + 1);

    return (
        <div className="top20-modal-overlay" onClick={(e) => { onClose(e); }}>
            <div className="top20-modal-content modal-box" data-modal-id={modalId} onClick={e => e.stopPropagation()}>
                <div className="top20-modal-header">
                    <div className="top20-title-container">
                        <h3>Top 20: {raceName}</h3>
                        <button 
                            className="notes-history-icon-btn"
                            onClick={() => onOpenNotes(raceName)}
                            title="Notities voor deze wedstrijd"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                        </button>
                    </div>
                    <button className="top20-close-btn" onClick={(e) => { 
                        e.preventDefault(); 
                        e.stopPropagation(); 
                        setTimeout(onClose, 50); 
                    }}>✕</button>
                </div>

                <div className="top20-body">
                    <div className="top20-table-wrapper">
                        <table className="top20-table">
                            <thead>
                                <tr>
                                    <th className="rank-col">#</th>
                                    {years.map(year => (
                                        <th key={year}>{year}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {ranks.map(rank => (
                                    <tr key={rank}>
                                        <td className="rank-num">{rank}</td>
                                        {years.map(year => {
                                            const name = raceData.Results[year]?.[rank - 1] || "ONBEKEND";
                                            if (name === "ONBEKEND") {
                                                return <td key={year} className="unknown-rider">ONBEKEND</td>;
                                            }

                                            // Only make clickable if the rider exists in our database (allRiders)
                                            const isClickable = allRiders && allRiders[name];

                                            return (
                                                <td key={year}>
                                                    <span
                                                        className={isClickable ? "top20-rider-link" : ""}
                                                        onClick={isClickable ? () => onRiderClick(name) : undefined}
                                                        title={isClickable ? "Klik voor historie" : undefined}
                                                        style={!isClickable ? { cursor: 'default' } : undefined}
                                                    >
                                                        {name}
                                                    </span>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="top20-footer">
                    <button className="top20-footer-close-btn" onClick={(e) => { 
                        if (e) {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                        }
                        setTimeout(onClose, 50); 
                    }}>Sluiten</button>
                </div>
            </div>
        </div>
    );
}

export default HistoricalTop20Modal;
